import {
  StatsSpeakRoot,
  StatsBox,
  StatsColumn,
  Header,
  Percentage,
  Subtitle,
} from './StatsSpeak.styles'
import { Stack } from 'components/Stack'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { ColorTokens } from '../../../../stitches.config'

export const StatsSpeak = ({ background }: { background?: ColorTokens }) => {
  const { t } = useTranslation()

  return (
    <StatsSpeakRoot>
      <Stack direction="column" alignItems="center">
        <Header>{t('why-we-feed-raw:stats.title')}</Header>
        <Subtitle>{t('why-we-feed-raw:stats.subtitle')}</Subtitle>
        <StatsBox css={{ background: background ? `$${background}` : 'tertiary-200' }}>
          <StatsColumn>
            <Percentage>{t('why-we-feed-raw:stats.statistics.0.percentage')}</Percentage>
            <Text size="body" align="center">
              {t('why-we-feed-raw:stats.statistics.0.description')}
            </Text>
          </StatsColumn>

          <StatsColumn>
            <Percentage>{t('why-we-feed-raw:stats.statistics.1.percentage')}</Percentage>
            <Text size="body" align="center">
              {t('why-we-feed-raw:stats.statistics.1.description')}
            </Text>
          </StatsColumn>

          <StatsColumn>
            <Percentage>{t('why-we-feed-raw:stats.statistics.2.percentage')}</Percentage>
            <Text size="body" align="center">
              {t('why-we-feed-raw:stats.statistics.2.description')}
            </Text>
          </StatsColumn>
        </StatsBox>
      </Stack>
    </StatsSpeakRoot>
  )
}

StatsSpeak.displayName = 'WhyWeFeedRawStatsSpeak'
